<template>
  <div class="vet-slider relative">
    <splide
      ref="splide"
      :options="options"
    >
      <slot />
    </splide>
    <vetster-carousel-buttons
      class="mt-8 flex justify-center lg:justify-normal lg:relative lg:w-max lg:left-[29rem] space-x-6 ml-2 md:ml-6 lg:ml-0"
      @next="nextSlide"
      @prev="prevSlide"
    />
  </div>
</template>

<script>
// Package "@splidejs/vue-splide" installs the below file, ESLint is wrong.
// eslint-disable-next-line import/no-extraneous-dependencies
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import Splide from '@/components/Splide/Splide';
import VetsterCarouselButtons from '@/components/VetsterCarouselButtons';
import Breakpoint from '@/enums/Breakpoint';

export default {
  name: 'VetsterVetSlider',

  components: {
    Splide,
    VetsterCarouselButtons,
  },

  props: {
    showArrows: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      options: {
        type: 'loop',
        focus: 0,
        gap: '56px',
        autoWidth: true,
        arrows: this.showArrows,
        pagination: false,
        breakpoints: {
          [Breakpoint.Medium]: {
            gap: '24px',
            focus: 'center',
          },
          [Breakpoint.Large]: {
            gap: '12px',
            focus: 'center',
          },
        },
      },
    };
  },

  methods: {
    prevSlide() {
      this.$refs.splide.go('-');
    },
    nextSlide() {
      this.$refs.splide.go('+');
    },
  },
};
</script>

<style>
.vet-slider .splide__slide {
  opacity: 0.5;
  transition: opacity 0.2s;
  transition-timing-function: cubic-bezier(.49,.22,.83,.67);
}
.vet-slider .splide__slide.is-active {
  opacity: 1;
}
</style>
